function read_more_content() {
  const readmoreItems = document.querySelectorAll(".readmore-content");
  if (readmoreItems) {
    readmoreItems.forEach(element => {
      const trigger = element.querySelector(".readmore-trigger");
      const content = element.querySelector(".readmore-text");
      if (trigger && content) {
        trigger.addEventListener("click", e => { toggle_read_more(element); });
      }
    });
  }

  function toggle_read_more(element) {
    element.classList.add("readmore-open");
  }
}
read_more_content();